import React from 'react';
import { Bot, Cpu, Terminal, Puzzle, LayoutGrid, Heart, ShoppingCart, ClipboardList } from 'lucide-react';

const categoryIcons = {
  'All': LayoutGrid,
  'Robot Designs': Bot,
  'Hardware': Cpu,
  'ROS2 Packages': Terminal,
  'Studio Plugins': Puzzle,
};

const Sidebar = ({ categories, activeCategory, onCategoryChange, activeView, onViewChange, cartCount }) => {
  return (
    <aside className="w-64 flex-shrink-0 h-[calc(100vh-73px)] sticky top-[73px] glass-frosted border-r border-subtle overflow-y-auto">
      <div className="p-4 space-y-6">
        {/* Categories */}
        <div>
          <h3 className="text-xs font-bold tracking-[0.15em] text-foreground-muted px-3 mb-2">CATEGORIES</h3>
          <nav className="space-y-0.5">
            {categories.map((cat) => {
              const Icon = categoryIcons[cat] || LayoutGrid;
              const isActive = activeCategory === cat && activeView === 'browse';
              return (
                <button
                  key={cat}
                  onClick={() => { onCategoryChange(cat); onViewChange('browse'); }}
                  className={`flex items-center gap-3 w-full px-3 py-2 rounded-lg text-sm font-medium transition-smooth ${
                    isActive ? 'text-foreground-primary' : 'text-foreground-secondary hover:text-foreground-primary hover:bg-subtle'
                  }`}
                  style={isActive ? { background: 'rgba(249,115,22,0.1)', color: '#F97316' } : {}}
                >
                  <Icon size={16} />
                  {cat}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Divider */}
        <div className="border-t border-subtle" />

        {/* Actions */}
        <div>
          <h3 className="text-xs font-bold tracking-[0.15em] text-foreground-muted px-3 mb-2">MY STORE</h3>
          <nav className="space-y-0.5">
            <button
              onClick={() => onViewChange('cart')}
              className={`flex items-center justify-between w-full px-3 py-2 rounded-lg text-sm font-medium transition-smooth ${
                activeView === 'cart' ? 'text-foreground-primary' : 'text-foreground-secondary hover:text-foreground-primary hover:bg-subtle'
              }`}
              style={activeView === 'cart' ? { background: 'rgba(249,115,22,0.1)', color: '#F97316' } : {}}
            >
              <span className="flex items-center gap-3"><ShoppingCart size={16} /> Cart</span>
              {cartCount > 0 && (
                <span className="text-[10px] font-bold px-1.5 py-0.5 rounded-full" style={{ background: '#F97316', color: '#0B0E13' }}>
                  {cartCount}
                </span>
              )}
            </button>
            <button
              onClick={() => onViewChange('wishlist')}
              className={`flex items-center gap-3 w-full px-3 py-2 rounded-lg text-sm font-medium transition-smooth ${
                activeView === 'wishlist' ? 'text-foreground-primary' : 'text-foreground-secondary hover:text-foreground-primary hover:bg-subtle'
              }`}
              style={activeView === 'wishlist' ? { background: 'rgba(249,115,22,0.1)', color: '#F97316' } : {}}
            >
              <Heart size={16} /> Wishlist
            </button>
            <button
              onClick={() => onViewChange('orders')}
              className={`flex items-center gap-3 w-full px-3 py-2 rounded-lg text-sm font-medium transition-smooth ${
                activeView === 'orders' ? 'text-foreground-primary' : 'text-foreground-secondary hover:text-foreground-primary hover:bg-subtle'
              }`}
              style={activeView === 'orders' ? { background: 'rgba(249,115,22,0.1)', color: '#F97316' } : {}}
            >
              <ClipboardList size={16} /> My Orders
            </button>
          </nav>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
